import { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { AppChartCard } from '../@dashboard/app';
import useOptimizationData from '../../hooks/useOptimizationData';

const minH = { minHeight: 320 };

export default function OptimizationChart({
  site,
  startDate,        
  endDate,         
  msSessionInfo,
  expandContractChart,
  refreshKey,
}) {

  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  const { loading, series = [] } = useOptimizationData({
    site,
    msSessionInfo,
    startDate,
    endDate,
    inView: inView && !!startDate && !!endDate,  
    refreshKey,
  });

  const hasData = useMemo(
    () => series.some(s => (s?.data?.length ?? 0) > 0),
    [series]
  );

 
  if (!inView) {
    return <div ref={ref} style={minH} />;
  }


  if (loading) {
    return (
      <div
        ref={ref}
        style={{ ...minH, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress />
      </div>
    );
  }

  // No data
  if (!hasData) {
    return <div ref={ref} style={minH} />;
  }

  // Chart
  return (
    <div ref={ref}>
      <AppChartCard
        title="Optimization Strategy"
        subheader="Battery Power (MW) and SOC (%)"
        xAxisLabel="Hour Beginning"
        expandContractChart={expandContractChart}
        doubleYAxis
        chartData={series}                 
        xMinMs={startDate?.valueOf?.()}
        xMaxMs={endDate?.valueOf?.()}
      />
    </div>
  );
}

OptimizationChart.propTypes = {
  site: PropTypes.object.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  msSessionInfo: PropTypes.object.isRequired,
  expandContractChart: PropTypes.func,
  refreshKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
